import { CREDIT_NOTE_STATUS, CREDIT_NOTE_TYPE } from "./apiContract";

const now = new Date();
const daysAgo = (n) =>
  new Date(now.getTime() - n * 24 * 60 * 60 * 1000).toISOString();

/** Dealer dashboard → Credit Notes tab */
export const MOCK_DEALER_CREDIT_NOTES = [
  {
    id: 1,
    identifier: "CN-0001",
    status: CREDIT_NOTE_STATUS.OPEN,
    value: 10000,
    balance: 9000,
    type: CREDIT_NOTE_TYPE.DEALER,
    party_name: "Acme Interiors",
    store_dealer_id: 1,
    store_buyer_id: null,
    last_adjusted_at: daysAgo(2),
  },
  {
    id: 2,
    identifier: "CN-0002",
    status: CREDIT_NOTE_STATUS.OPEN,
    value: 5000,
    balance: 5000,
    type: CREDIT_NOTE_TYPE.DEALER,
    party_name: "Acme Interiors",
    store_dealer_id: 1,
    store_buyer_id: null,
    last_adjusted_at: null,
  },
  {
    id: 3,
    identifier: "CN-0003",
    status: CREDIT_NOTE_STATUS.CLOSED,
    value: 3000,
    balance: 0,
    type: CREDIT_NOTE_TYPE.DEALER,
    party_name: "Acme Interiors",
    store_dealer_id: 1,
    store_buyer_id: null,
    last_adjusted_at: daysAgo(45),
  },
  {
    id: 4,
    identifier: "CN-0004",
    status: CREDIT_NOTE_STATUS.OPEN,
    value: 15000,
    balance: 12500,
    type: CREDIT_NOTE_TYPE.DEALER,
    party_name: "Acme Interiors",
    store_dealer_id: 1,
    store_buyer_id: null,
    last_adjusted_at: daysAgo(10),
  },
];

/** Buyer nav → My Credits */
export const MOCK_BUYER_CREDIT_NOTES = [
  {
    id: 101,
    identifier: "CN-0042",
    status: CREDIT_NOTE_STATUS.OPEN,
    value: 5000,
    balance: 3000,
    type: CREDIT_NOTE_TYPE.DIRECT_BUYER,
    party_name: "Priya Homes",
    store_dealer_id: null,
    store_buyer_id: 1,
    last_adjusted_at: daysAgo(5),
  },
  {
    id: 102,
    identifier: "CN-0043",
    status: CREDIT_NOTE_STATUS.OPEN,
    value: 2000,
    balance: 2000,
    type: CREDIT_NOTE_TYPE.DIRECT_BUYER,
    party_name: "Priya Homes",
    store_dealer_id: null,
    store_buyer_id: 1,
    last_adjusted_at: null,
  },
  {
    id: 103,
    identifier: "CN-0044",
    status: CREDIT_NOTE_STATUS.CLOSED,
    value: 8000,
    balance: 0,
    type: CREDIT_NOTE_TYPE.DIRECT_BUYER,
    party_name: "Priya Homes",
    store_dealer_id: null,
    store_buyer_id: 1,
    last_adjusted_at: daysAgo(60),
  },
];

export const MOCK_ADJUSTMENTS_BY_CREDIT_NOTE_ID = {
  1: [
    {
      id: 11,
      credit_note_id: 1,
      project_id: 501,
      project_name: "Ravi Kitchen — Koramangala",
      project_value: 124500,
      customer_name: "Ravi Kumar",
      value: 1000,
      adjusted_at: daysAgo(2),
    },
  ],
  4: [
    {
      id: 41,
      credit_note_id: 4,
      project_id: 502,
      project_name: "Sunrise Office Fit-out",
      project_value: 287800,
      customer_name: "Metro Builders Pvt Ltd",
      value: 2500,
      adjusted_at: daysAgo(10),
    },
  ],
  101: [
    {
      id: 111,
      credit_note_id: 101,
      project_id: 601,
      project_name: "Priya Wardrobe — Master Bed",
      project_value: 68900,
      value: 2000,
      adjusted_at: daysAgo(5),
    },
  ],
  103: [
    {
      id: 131,
      credit_note_id: 103,
      project_id: 598,
      project_name: "Old Living Room",
      project_value: 156200,
      value: 8000,
      adjusted_at: daysAgo(60),
    },
  ],
};

export const MOCK_AVAILABLE_CREDIT_NOTES_DEALER = MOCK_DEALER_CREDIT_NOTES.filter(
  (n) => n.status === CREDIT_NOTE_STATUS.OPEN && n.balance > 0
).map(({ id, identifier, balance, status }) => ({
  id,
  identifier,
  balance,
  status,
}));

export const MOCK_AVAILABLE_CREDIT_NOTES_BUYER = MOCK_BUYER_CREDIT_NOTES.filter(
  (n) => n.status === CREDIT_NOTE_STATUS.OPEN && n.balance > 0
).map(({ id, identifier, balance, status }) => ({
  id,
  identifier,
  balance,
  status,
}));

const ORDER_CREDIT_SCENARIOS = [
  {
    credit_adjustments_total: 1000,
    credit_note_identifiers: ["CN-0001"],
  },
  {
    credit_adjustments_total: 0,
    credit_note_identifiers: [],
  },
  {
    credit_adjustments_total: 3500,
    credit_note_identifiers: ["CN-0001", "CN-0002"],
  },
  {
    credit_adjustments_total: 2500,
    credit_note_identifiers: ["CN-0004"],
  },
];

/** My Orders + dealer order cards — varied credit used / not used */
export function enrichProjectListCreditMock(projects) {
  if (process.env.REACT_APP_USE_CREDIT_NOTE_MOCKS !== "true") return projects;
  let orderIdx = 0;
  return (Array.isArray(projects) ? projects : []).map((p) => {
    const st = String(p?.status || "").toLowerCase();
    if (st === "draft") return p;
    const scenario =
      ORDER_CREDIT_SCENARIOS[orderIdx % ORDER_CREDIT_SCENARIOS.length];
    orderIdx += 1;
    return { ...p, ...scenario };
  });
}

/** Project summary offcanvas — dealer path (has dealer / mode dealer) */
export const MOCK_SUMMARY_CREDIT_EXTENSIONS_DEALER = {
  dealer_discounts: [
    { per: 10, value: 10000, effective_value: 9000 },
    { per: 5, value: 9000, effective_value: 8550 },
  ],
  dealer_price: 8550,
  credit_adjustments_total: 0,
};

/** Project summary — direct buyer (no dealer on project) */
export const MOCK_SUMMARY_CREDIT_EXTENSIONS_DIRECT = {
  dealer_discounts: [],
  dealer_price: null,
  credit_adjustments_total: 0,
};

/** Example: order already has credit applied (for placed+ UX) */
export const MOCK_SUMMARY_CREDIT_EXTENSIONS_DEALER_PLACED = {
  ...MOCK_SUMMARY_CREDIT_EXTENSIONS_DEALER,
  credit_adjustments_total: 1000,
};

export const MOCK_SUMMARY_CREDIT_EXTENSIONS = {
  dealer: MOCK_SUMMARY_CREDIT_EXTENSIONS_DEALER,
  direct: MOCK_SUMMARY_CREDIT_EXTENSIONS_DIRECT,
  dealer_placed: MOCK_SUMMARY_CREDIT_EXTENSIONS_DEALER_PLACED,
};
